import { h, render, Component } from 'preact';
import TxrMobileHeader from './txr-mobile-header';
import TxrNavSubmenuProduct from './txr-nav-submenu-product';
import TxrNavSubmenuSolutions from './txr-nav-submenu-solutions';
import TxrNavSubmenuResources from './txr-nav-submenu-resources';
import TxrNavSubmenuCompany from './txr-nav-submenu-company';

import { classNames } from '../utils/utils';

class TxrNavbar extends Component {
    state = {
        openedSubmenu: undefined,
        forceClose: false,
        isProductMenu: false,
        isSolutionsMenu: false,
        isResourcesMenu: false,
        isCompanyMenu: false,
        isPricingMenu: false
    }
    componentDidMount() {
        setTimeout(() => {
            this.calcSelectedMenu();
        }, 100);
        
    }
    close() {
        if (this.state.openedSubmenu) {
            this.setState({ forceClose: true });
            setTimeout(() => {
                this.setState({ forceClose: false });
            }, 500);
        }
        this.closeSubmenu();
        this.props.onClose();
    }
    openSubmenu(menu) {
        this.setState({ openedSubmenu: menu });
    }
    closeSubmenu() {
        this.setState({ openedSubmenu: undefined });
        //<TxrMobileHeader onClose={() => this.close()} />
    }
    calcSelectedMenu() {
        const url =  window.location.href || ''; 
        if(url.indexOf('security') !== -1) {
            this.setState({ isProductMenu: true });
        } else {
            this.setState({ isProductMenu: false });
        }
        if(url.indexOf('resources') !== -1 || url.indexOf('articles') !== -1 || url.indexOf('case-studies') !== -1) {
            this.setState({ isResourcesMenu: true });
        } else {
            this.setState({ isResourcesMenu: false });
        }

        if(url.indexOf('about-us') !== -1 || url.indexOf('ContactUs') !== -1 || url.indexOf('partners') !== -1 || (url.indexOf('/news') !== -1 && url.indexOf('/newsletters') === -1 )) {
            this.setState({ isCompanyMenu: true });
        } else {
            this.setState({ isCompanyMenu: false });
        }
    }
    render() {
        return (
            <div class={classNames({ 'txr-navbar': true, 'txr-mobile-menu__opened': this.props.isMobileMenuOpened, 'txr-white-header': this.props.isWhiteHeader })}>
                <div class={'txr-navbar-content' + (this.state.openedSubmenu ? ' txr-navbar-mobile__submenu-opened' : '') + (this.state.forceClose ? ' txr-navbar-content__force-close' : '')}>
                    <TxrMobileHeader onClose={() => this.close()}></TxrMobileHeader>
                    <nav class="txr-navbar">
                        <ul class="txr-navbar__nav">
                            <li class={'txr-nav-item ' + (this.state.isProductMenu ? 'txr-nav-item__selected' : '')}>
                                <a class="txr-nav-item__link" href="/product">Product</a>
                                <div class="txr-nav-item__content">
                                    <div class="txr-nav-item__content-shadow">
                                        <TxrNavSubmenuProduct />
                                    </div>
                                </div>
                            </li>
                            <li class="txr-nav-item">
                                <a class="txr-nav-item__link" href="/solutions">Solutions</a>
                                <div class="txr-nav-item__content">
                                    <div class="txr-nav-item__content-shadow">
                                        <TxrNavSubmenuSolutions />
                                    </div>
                                </div>
                            </li>
                            <li class={'txr-nav-item ' + (this.state.isResourcesMenu ? 'txr-nav-item__selected' : '')}>
                                <a class="txr-nav-item__link" href="/resources/all">Resources</a>
                                <div class="txr-nav-item__content">
                                    <div class="txr-nav-item__content-shadow">
                                        <TxrNavSubmenuResources />
                                    </div>
                                </div>
                            </li>
                            <li class={'txr-nav-item ' + (this.state.isCompanyMenu ? 'txr-nav-item__selected' : '')}>
                                <a class="txr-nav-item__link" href="/about">Company</a>
                                <div class="txr-nav-item__content">
                                    <div class="txr-nav-item__content-shadow">
                                        <TxrNavSubmenuCompany />
                                    </div>
                                </div>
                            </li>
                            <li class="txr-nav-item  txr-nav-item__last">
                                <a class="txr-nav-item__link" href="/pricing">Pricing</a>
                            </li>                            
                        </ul>

                        <div class="txr-navbar-mobile__nav">
                            <div class="txr-nav-item" onClick={() => this.openSubmenu('product')}>
                                <div class="txr-nav-item__link">Product</div>
                                <img class="txr-nav-item__mobile-button" src="/images/navigation/icon-arrow-nav.svg" alt="arrow"></img>
                            </div>
                            <div class="txr-nav-item" onClick={() => this.openSubmenu('solutions')}>
                                <div class="txr-nav-item__link">Solutions</div>
                                <img class="txr-nav-item__mobile-button" src="/images/navigation/icon-arrow-nav.svg" alt="arrow"></img>
                            </div>
                            <div class="txr-nav-item" onClick={() => this.openSubmenu('resources')}>
                                <div class="txr-nav-item__link">Resources</div>
                                <img class="txr-nav-item__mobile-button" src="/images/navigation/icon-arrow-nav.svg" alt="arrow"></img>
                            </div>
                            <div class="txr-nav-item" onClick={() => this.openSubmenu('company')}>
                                <div class="txr-nav-item__link">Company</div>
                                <img class="txr-nav-item__mobile-button" src="/images/navigation/icon-arrow-nav.svg" alt="arrow"></img>
                            </div>
                            <div class="txr-nav-item">
                                <a class="txr-nav-item__link" href="/pricing">Pricing</a>
                            </div>                                                                                    
                        </div>

                        <div class="txr-navbar-mobile__buttons">
                            <a class="txr-nav-button__link" href="https://app.textrequest.com/app/login">Login</a>
                            <a class="txr-nav-button__link" href="/pricing">Try It Free</a>
                            {/*<a class="txr-nav-button__link" href="/pricing">Sign Up</a>*/}
                            
                            <a class="txr-nav-button__link" href="/demo">Get a Demo</a>
                        </div>
                        <div class="txr-navbar-mobile__footer">
                            Text us or call<span class="txr-nav-button__link">423-218-0111</span>
                        </div>
                    </nav>
                </div>
                <div class={classNames({ 'txr-navbar-mobile__submenu': true, 'txr-navbar-mobile__submenu-opened': !!this.state.openedSubmenu, 'txr-navbar-content__force-close': this.state.forceClose })}>
                    
                    { this.state.openedSubmenu === 'product' && <TxrNavSubmenuProduct onClose={() => this.closeSubmenu()}></TxrNavSubmenuProduct> }
                    { this.state.openedSubmenu === 'solutions' && <TxrNavSubmenuSolutions onClose={() => this.closeSubmenu()}></TxrNavSubmenuSolutions> }
                    { this.state.openedSubmenu === 'resources' && <TxrNavSubmenuResources onClose={() => this.closeSubmenu()}></TxrNavSubmenuResources> }
                    { this.state.openedSubmenu === 'company' && <TxrNavSubmenuCompany onClose={() => this.closeSubmenu()}></TxrNavSubmenuCompany> }
                </div>
                
            </div>
        )
    }
}

export default TxrNavbar;